import NewFireIcon from 'assets/svg/New_fireIcon'
import NewLightIcon from 'assets/svg/New_lightIcon'
import NewMoneyIcon from 'assets/svg/New_moneyIcon'
import LOCALES, { TLocaleCode } from 'constants/locales'
import React from 'react'
import { TFunction } from 'src/providers/TranslateProvider/TranslateProvider'
import { BadgeType, Strapi_Navbar } from 'src/types'
import { CopytadingTopTradersMobile } from 'components/Header/components/CopytadingTopTradersMobile'
import { DEFAULT_LOCALE, GATSBY_MAIN_URL } from '@constants'
import { freshchatService } from '@margex/ui'

const getHeaderMobileNavBarData = (t: TFunction, locale: string) => {
  const locales = LOCALES.map(item => item.code)

  const blogLocalesWithoutPath = ['en', 'ru', 'fa', 'ko']

  const mobileNavBarData: Array<MobileNavBaraDataType> = [
    {
      id: '1',
      attributes: {
        name: t('Margex Platform'),
        dropdown: true,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('About Us'),
                url: '/about-us',
              },
            },
            {
              attributes: {
                name: t('Fees'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/margex-fees`
                    : `${GATSBY_MAIN_URL}/${locale}/margex-fees`,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Help Center'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/help-center`
                    : `${GATSBY_MAIN_URL}/${locale}/help-center`,

                badgeType: BadgeType.Popular,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Security'),
                url: '/platforms-security',
              },
            },
            {
              attributes: {
                name: t('Contact Us'),
                url: '/contact-us',
              },
            },
            {
              attributes: {
                name: t('Live chat'),
                url: '',
                badgeType: BadgeType.Popular,
                showChat(id?: boolean) {
                  if (!id || typeof window === 'undefined') {
                    return
                  }
                  freshchatService.open()
                },
              },
            },
          ],
        },
        locale: undefined,
        order: 2,
      },
    },
    {
      id: '2',
      attributes: {
        name: t('Blog and News'),
        dropdown: true,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('For beginners'),
                url: blogLocalesWithoutPath.includes(locale)
                  ? 'https://margex.com/blog/for-beginners'
                  : `https://margex.com/${locale}/blog/for-beginners`,
                badgeType: BadgeType.Hot,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Trading articles'),
                url: blogLocalesWithoutPath.includes(locale)
                  ? 'https://margex.com/blog/trading'
                  : `https://margex.com/${locale}/blog/trading`,
                urlEn: 'https://margex.com/blog/trading-strategies',
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Popular'),
                url: blogLocalesWithoutPath.includes(locale)
                  ? 'https://margex.com/blog/for-beginners'
                  : `https://margex.com/${locale}/blog/for-beginners`,
                includeLangsArr: locales,
              },
            },
          ],
        },
        locale: undefined,
        order: 2,
      },
    },
    {
      id: '44',
      attributes: {
        name: t('buy crypto'),
        dropdown: false,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: { name: '', url: '/buy-crypto' },
            },
          ],
        },
        locale: undefined,
        order: 4,
      },
    },
    {
      id: '3',
      attributes: {
        name: t('futures'),
        dropdown: true,
        warning: undefined,
        withLocale: false,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('COIN-M'),
                url: `${GATSBY_MAIN_URL}/app/trade`,
                badgeType: BadgeType.Popular,
              },
            },
            {
              attributes: {
                name: t('USDT-M'),
                url: `${GATSBY_MAIN_URL}/app/trade`,
                badgeType: BadgeType.Popular,
              },
            },
            {
              attributes: {
                name: t('Simulated'),
                url: 'https://margex.com/blog/risk-free-margin-trading-with-up-to-100x-leverage-on-margex',
                badgeType: BadgeType.New,
              },
            },
            {
              attributes: {
                name: t('Demo live'),
                url: `${GATSBY_MAIN_URL}/trade/btcusd`,
              },
            },
          ],
        },
        locale: undefined,
        order: 3,
      },
    },
    {
      id: '3213',
      attributes: {
        name: t('spot'),
        dropdown: true,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('Convert crypto'),
                url: '',
                badgeType: BadgeType.Soon,
              },
            },
            {
              attributes: {
                name: t('Spot trading'),
                url: '',
                badgeType: BadgeType.InDevelopment,
              },
            },
          ],
        },
        locale: undefined,
        order: 3,
      },
    },
    {
      id: '331233',
      attributes: {
        name: t('explore trading'),
        dropdown: true,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('Quick start guide'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/quick-start-guide/`
                    : `${GATSBY_MAIN_URL}/${locale}/quick-start-guide/`,
                badgeType: BadgeType.Hot,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Video tutorials'),
                url: 'https://www.youtube.com/c/margex',
                badgeType: BadgeType.Popular,
              },
            },
            {
              attributes: {
                name: t('How to make a deposit'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/how-to-deposit`
                    : `${GATSBY_MAIN_URL}/${locale}/how-to-deposit`,

                badgeType: BadgeType.Popular,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('How to buy crypto'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/where-to-buy-bitcoin`
                    : `${GATSBY_MAIN_URL}/${locale}/where-to-buy-bitcoin`,
                badgeType: BadgeType.BestOffer,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Leverage Trading and Margin'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/how-leverage-works`
                    : `${GATSBY_MAIN_URL}/${locale}/how-leverage-works`,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Trading on Margex'),
                url:
                  locale === DEFAULT_LOCALE
                    ? `${GATSBY_MAIN_URL}/trading-interface-overview`
                    : `${GATSBY_MAIN_URL}/${locale}/trading-interface-overview`,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Cross vs Isolated Margin'),
                url: '/cross-margin-vs-isolated-margin',
              },
            },
            {
              attributes: {
                name: t('Crypto Futures trading'),
                url: '/crypto-futures-trading',
              },
            },
            {
              attributes: {
                name: t('How to short crypto'),
                url: '/how-to-short-crypto',
              },
            },
          ],
        },
        locale: undefined,
        order: 3,
      },
    },
    {
      id: '222333',
      iconLink: <NewFireIcon red />,
      attributes: {
        name: t('Copy Trading'),
        dropdown: true,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: {
                name: t('Download App'),
                url: 'https://copytrading.margex.com/2qXj',
                badgeType: BadgeType.Download,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Start Copy Trading'),
                url: `${GATSBY_MAIN_URL}/app/copytrading`,
                badgeType: BadgeType.Hot,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Copy Trading Overview'),
                url: '/copytrading',
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('Create a public strategy'),
                url: `${GATSBY_MAIN_URL}/app/copytrading/create`,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: t('How to Start Following a Public Trader?'),
                url: `${GATSBY_MAIN_URL}/how-to-follow-a-strategy-quick-start`,
                includeLangsArr: locales,
              },
            },
            {
              attributes: {
                name: '',
                url: '',
                component: CopytadingTopTradersMobile,
              },
            },
          ],
        },
        locale: undefined,
        order: 4,
      },
    },
    {
      id: '1245',
      attributes: {
        name: t('staking'),
        dropdown: false,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: { name: '', url: '/staking' },
            },
          ],
        },
        locale: undefined,
        order: 5,
      },
    },
    {
      id: '4123',
      iconLink: <NewLightIcon />,
      attributes: {
        name: t('price alerts'),
        dropdown: false,
        warning: undefined,
        withLocale: false,
        navbarLinks: {
          data: [
            {
              attributes: { name: '', url: '/crypto-alerts' },
            },
          ],
        },
        locale: undefined,
        order: 4,
      },
    },
    {
      id: '61',
      iconLink: <NewMoneyIcon green />,
      attributes: {
        name: t('Referral'),
        dropdown: false,
        warning: undefined,
        withLocale: true,
        navbarLinks: {
          data: [
            {
              attributes: { name: '', url: '/referral' },
            },
          ],
        },
        locale: undefined,
        order: 6,
      },
    },
  ]

  return mobileNavBarData
}

export default getHeaderMobileNavBarData

interface IncludeLangsArr {
  includeLangsArr?: TLocaleCode[]
}

type ExtendedStrapi_Navbar = Strapi_Navbar & IncludeLangsArr
interface MobileNavBaraDataType {
  attributes: ExtendedStrapi_Navbar
  iconLink?: JSX.Element
  id: string
  // includeLangsArr?: TLocaleCode[]
}
